import i18next from 'i18next';
import { UserStatus } from '../../types/planung-graphql-client-defs';

export function getUserStatusTranslation(status?: UserStatus | null) {
  switch (status) {
    case UserStatus.Full:
      return i18next.t('users.status.full');
    case UserStatus.Invited:
      return i18next.t('users.status.invited');
    case UserStatus.None:
    case UserStatus.ImpersonateOnly:
      return i18next.t('users.status.none');
    default:
      return i18next.t('users.status.unknown');
  }
}
